import { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { Shield } from 'lucide-react';

/**
 * PrivacyPolicyPage - Static placeholder privacy policy page
 */
export const PrivacyPolicyPage: FC = () => {
  return (
    <>
      <Helmet>
        <title>Privacy Policy | Massatherapy</title>
        <meta
          name="description"
          content="Read the Massatherapy privacy policy to understand how we handle your personal data."
        />
      </Helmet>

      <div className="min-h-screen bg-gray-50 dark:bg-slate-900 py-12 px-4">
        <div className="mx-auto max-w-3xl">
          <div className="backdrop-blur-lg bg-white/90 dark:bg-slate-800/90 rounded-2xl shadow-lg border border-white/20 dark:border-slate-700/50 p-8 sm:p-12">
            <div className="flex items-center gap-3 mb-6">
              <div className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-100 dark:bg-primary-900/30">
                <Shield className="h-6 w-6 text-primary-600 dark:text-primary-400" aria-hidden="true" />
              </div>
              <h1 className="text-3xl font-bold text-gray-900 dark:text-slate-100">
                Privacy Policy
              </h1>
            </div>

            <p className="text-sm text-gray-500 dark:text-slate-400 mb-8">
              Last updated: February 2026
            </p>

            <div className="prose dark:prose-invert max-w-none">
              <p className="text-gray-600 dark:text-slate-400 leading-relaxed">
                This privacy policy will be updated with our full privacy policy soon.
                For questions, please{' '}
                <Link
                  to="/contact"
                  className="text-primary-600 hover:text-primary-700 dark:text-primary-400 dark:hover:text-primary-300 underline"
                >
                  contact us
                </Link>
                .
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

PrivacyPolicyPage.displayName = 'PrivacyPolicyPage';

export default PrivacyPolicyPage;
